/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Qr_HintInputs */

const vi_cdo_qr_hint = /** @type {(inputs: Cdo_Qr_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài xế quét mã này để nhận đơn; quét lại khi giao xong để xác nhận đã giao.`)
};

/**

* @param {Cdo_Qr_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_qr_hint = /** @type {((inputs?: Cdo_Qr_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Qr_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_qr_hint(inputs)
});